// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"779e74b5","200":"779e74b5","301":"f15da1b8","324":"f15da1b8","528":"7cb776f1","753":"779e74b5","795":"7cb776f1","889":"f15da1b8","891":"f15da1b8"}[chunkId] + ".chunk.css";
};